<template>
  <div>
    <EditableTable
      v-model="nfseConfigurations.series"
      :fields="fields"
      :newRowButtonTitle="'Nova Série'"
    />
  </div>
</template>

<script>
import { EditableTable } from '@/components';
import { mapState } from 'vuex';

export default {
  name: 'Series',
  components: { EditableTable },
  data() {
    return {
      fields: [
        {
          key: 'serie',
          label: 'Série',
          type: 'input',
          required: true,
          maxLength: 6,
        },
        {
          key: 'internalNumber',
          label: 'Próxima NFS-e',
          type: 'inputNumber',
          required: true,
        },
        { key: 'rps', label: 'RPS', type: 'inputNumber', required: true },
        { key: 'batch', label: 'Lote', type: 'inputNumber', required: true },
        {
          key: 'active',
          label: 'Ativo',
          type: 'checkboxSwitch',
          thStyle: 'width: 100px',
        },
        { key: 'edit', label: '', type: 'edit', thStyle: 'width: 80px' },
      ],
    };
  },
  computed: {
    ...mapState('nfseConfigurations', ['nfseConfigurations']),
  },
};
</script>
